export default __webpack_public_path__ + "static/media/addIcon.13b73abc.svg";